<div class="contenedor-dialog" *appRole="['IndiceAjusteContrato.TraerDelBCRA']">

  <ngx-spinner [zIndex]="100" name="spImportarBcra" bdColor="rgba(255,255,255,0.8)" size="default"
    color="#009688" type="ball-atom" [fullScreen]="false"></ngx-spinner>

  <button mat-icon-button class="close-button" (click)="cerrar()">
    <mat-icon class="close-icon" color="warn">close</mat-icon>
  </button>

  <h1 mat-dialog-title>Importar índices del <strong>BCRA</strong></h1>
  <mat-divider></mat-divider>

  <div mat-dialog-content>

    <p class="nota">
      <mat-icon>info_outline</mat-icon>
      Los valores que ya estén cargados se saltean, no se pisan. Podés reimportar
      el mismo rango sin problema.
    </p>

    <form [formGroup]="form">
      <div class="row">
        <div class="col-lg-4">
          <mat-form-field class="full-width">
            <mat-label>Índice</mat-label>
            <mat-select formControlName="idTipoAjusteContrato">
              <mat-option *ngFor="let tipo of tiposDisponibles; trackBy: trackByItems" [value]="tipo.id">
                {{ tipo.descripcion }}
              </mat-option>
            </mat-select>
            <mat-hint>El IPC lo publica el INDEC, se carga a mano</mat-hint>
          </mat-form-field>
        </div>

        <div class="col-lg-4">
          <mat-form-field class="full-width">
            <mat-label>Desde</mat-label>
            <input matInput [matDatepicker]="pickerDesde" formControlName="fechaDesde">
            <mat-datepicker-toggle matSuffix [for]="pickerDesde"></mat-datepicker-toggle>
            <mat-datepicker #pickerDesde startView="multi-year"></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="col-lg-4">
          <mat-form-field class="full-width">
            <mat-label>Hasta</mat-label>
            <input matInput [matDatepicker]="pickerHasta" formControlName="fechaHasta">
            <mat-datepicker-toggle matSuffix [for]="pickerHasta"></mat-datepicker-toggle>
            <mat-datepicker #pickerHasta startView="multi-year"></mat-datepicker>
          </mat-form-field>
        </div>
      </div>
    </form>

    <!-- ===== Resultado ===== -->
    <ng-container *ngIf="hayResultado()">
      <h3 class="titulo-seccion">
        <mat-icon>fact_check</mat-icon> Resultado
      </h3>

      <div class="resumen">
        <span class="dato ok">
          <mat-icon>add_circle</mat-icon>
          <b>{{ resultado!.importados }}</b> importados
        </span>
        <span class="dato" *ngIf="resultado!.yaExistian > 0">
          <mat-icon>done_all</mat-icon>
          <b>{{ resultado!.yaExistian }}</b> ya estaban
        </span>
        <span class="dato alerta" *ngIf="resultado!.conError > 0">
          <mat-icon>error_outline</mat-icon>
          <b>{{ resultado!.conError }}</b> con error
        </span>
        <span class="dato total">
          <mat-icon>calendar_month</mat-icon>
          <b>{{ resultado!.totalRecibidos }}</b> valores en el rango
        </span>
      </div>

      <div class="tabla-container" *ngIf="dataSource.data.length > 0">
        <table mat-table [dataSource]="dataSource" class="tabla-resultado">
          <ng-container matColumnDef="fecha">
            <th mat-header-cell *matHeaderCellDef>Fecha</th>
            <td mat-cell *matCellDef="let i">{{ i.fecha | date:'dd/MM/yyyy' }}</td>
          </ng-container>

          <ng-container matColumnDef="valor">
            <th mat-header-cell *matHeaderCellDef class="col-valor text-right">Valor</th>
            <td mat-cell *matCellDef="let i" class="col-valor text-right">{{ i.valor }}</td>
          </ng-container>

          <ng-container matColumnDef="estado">
            <th mat-header-cell *matHeaderCellDef class="col-estado">Estado</th>
            <td mat-cell *matCellDef="let i" class="col-estado">
              <span class="chip" [class.nuevo]="i.estado === 'Importado'">{{ i.estado }}</span>
            </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="columnas"></tr>
          <tr mat-row *matRowDef="let fila; columns: columnas"></tr>
        </table>
      </div>

      <app-sin-datos *ngIf="dataSource.data.length === 0"
        icono="event_busy"
        mensaje="El BCRA no devolvió valores para ese rango"
        detalle="Puede que sean días no hábiles o que el índice no se publique en esas fechas."
        [compacto]="true">
      </app-sin-datos>

      <div class="errores" *ngIf="resultado!.errores.length > 0">
        <span class="titulo-errores"><mat-icon>warning</mat-icon> Valores que no se pudieron interpretar</span>
        <ul>
          <li *ngFor="let e of resultado!.errores; trackBy: trackByItems">{{ e }}</li>
        </ul>
      </div>
    </ng-container>
  </div>

  <mat-divider></mat-divider>

  <div mat-dialog-actions class="acciones">
    <button mat-raised-button color="primary" [disabled]="importando || form.invalid" (click)="importar()">
      <mat-icon>cloud_download</mat-icon>
      {{ hayResultado() ? 'Importar de nuevo' : 'Importar' }}
    </button>
    <button mat-button color="warn" (click)="cerrar()">
      <mat-icon>{{ hayResultado() ? 'check' : 'cancel' }}</mat-icon>
      {{ hayResultado() ? 'Listo' : 'Cancelar' }}
    </button>
  </div>

</div>
